import axios from '../helpers/axios';
import * as errors from '../errors';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const getPrivacys = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/privacys');
    dispatch({ type: 'SET_ALL_PRIVACYS', payload: res.data });
  } catch (e) {
    errors.handleErrorWithRedirectIfNotAuth(e);
  }
};

export const createPrivacy =
  (privacy: any, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.post('/api/privacy/', privacy);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyCreated'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'ADD_PRIVACY', payload: res.data });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const editPrivacy =
  (privacy: any, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await axios.put('/api/privacy/', privacy);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyEdited'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'EDIT_PRIVACY', payload: privacy });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const deletePrivacy =
  (privacy_id: string, notify: Notify): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      await axios.delete('/api/privacy/', { params: { privacy_id } });
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('successfullyDeleted'),
        status: 'success',
        position: 'top-center',
        dismissible: true,
        dismissAfter: 3000
      });
      dispatch({ type: 'REMOVE_PRIVACY', payload: privacy_id });
    } catch (e: any) {
      if (e?.response?.status === 428) {
        notify({
          title: getTranslationKey('error'),
          message: getTranslationKey('customDomains.deletePrivacyErrorInUse'),
          status: 'error',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 10000
        });
      } else errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };
